<template>
    <el-container style="padding: 24px; max-width: 800px; margin: auto;">
        <el-header style="font-size: 20px; font-weight: bold;">循环请求工具</el-header>
    
        <el-main>
            <el-form label-width="180px" :model="form">
                <el-form-item label="请求地址">
                    <el-input v-model="form.url" placeholder="https://example.com/api" />
                </el-form-item>
    
                <el-form-item label="FormData 参数">
                    <el-input v-model="form.formData" placeholder="key1=value1&key2=value2" />
                </el-form-item>
    
                <el-form-item label="请求间隔（秒）">
                    <el-input-number v-model="form.interval" :min="1" />
                </el-form-item>
    
                <el-form-item label="允许继续请求的关键词（多个用逗号分隔）">
                    <el-input v-model="form.stopKeyword" placeholder="例如: ok,success,done" />
                </el-form-item>
    
                <el-form-item>
                    <el-button @click="startRequest" type="primary" :disabled="isRunning">开始</el-button>
                    <el-button @click="stopRequest" type="danger" :disabled="!isRunning">停止</el-button>
                </el-form-item>
            </el-form>
    
            <el-card style="margin-top: 20px;">
                <template #header>
                    <span>日志输出</span>
                </template>
                <el-scrollbar height="300px">
                    <pre style="white-space: pre-wrap;">{{ log }}</pre>
                </el-scrollbar>
            </el-card>
        </el-main>
    </el-container>
</template>
  
  <script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'

const generateRandomString = (length = 12) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

const form = ref({
  url: 'https://cors.emas.workers.dev/api/index/getimg',
  formData: `key=${generateRandomString()}`, // 默认值
  interval: 3,
  stopKeyword: '送心员繁忙,订单不存在',
})

const shouldContinue = ref(true)
const isRunning = ref(false)
const log = ref('')
let timer = null

const appendLog = (text) => {
  const time = new Date().toLocaleTimeString()
  log.value += `[${time}] ${text}\n`
}

const parseFormData = (str) => {
  const formData = new FormData()
  const pairs = str.split('&')
  for (const pair of pairs) {
    const [key, value] = pair.split('=')
    if (key && value !== undefined) {
      formData.append(key, value)
    }
  }
  return formData
}

const sendRequest = async () => {
  if (!shouldContinue.value) {
    stopRequest()
    return
  }

  // 动态生成 FormData 参数
  form.value.formData = `key=${generateRandomString()}`

  try {
    const response = await fetch(form.value.url, {
      method: 'POST',
      body: parseFormData(form.value.formData),
    })
    const text = await response.text()
    appendLog(`请求参数: ${form.value.formData}`)
    appendLog(`响应: ${text}`)

    const keywords = form.value.stopKeyword.split(',').map(k => k.trim()).filter(k => k)
    const found = keywords.some(keyword => text.includes(keyword))

    if (!found) {
      appendLog('未匹配到任何关键词，自动停止请求。')
      await saveRequestResult(form.value.formData, text)
      stopRequest()
    }

  } catch (error) {
    appendLog(`请求失败: ${error.message}`)
    stopRequest()
  }
}
//cors.emas.workers.dev

const saveRequestResult = async (formDataText, responseText) => {
  try {
    const oldResp = await fetch('https://cors.emas.workers.dev/api/common_data/kvselect/sky')
    const rawText = await oldResp.text()
    console.log('🔍 kvselect 原始返回:', rawText)

    // ✅ 美化拼接内容
    const contentText = [
      '===== Old Data =====',
      indentText(rawText),
      '',
      '===== FormData Sent =====',
      indentText(formDataText),
      '',
      '===== Response Received =====',
      indentText(responseText)
    ].join('\n')

    console.log('📦 发送内容:\n' + contentText)

    const saveResp = await fetch('https://cors.emas.workers.dev/api/common_data/kvadd/sky', {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain'
      },
      body: contentText
    })

    if (!saveResp.ok) {
      appendLog(`⚠️ 保存失败：${saveResp.status}`)
    } else {
      appendLog(`✅ 已保存请求数据`)
    }
  } catch (err) {
    appendLog(`❌ 保存请求数据时出错: ${err.message}`)
  }
}

// 辅助函数：对每一行添加缩进
function indentText(text, prefix = '  ') {
  return text
    .split('\n')
    .map(line => prefix + line)
    .join('\n')
}




const startRequest = () => {
  if (!form.value.url) {
    ElMessage.error('请输入请求地址')
    return
  }
  if (timer) {
    ElMessage.warning('请求已在进行中')
    return
  }

  shouldContinue.value = true
  isRunning.value = true
  appendLog('开始请求...')
  sendRequest()
  timer = setInterval(sendRequest, form.value.interval * 1000)
}

const stopRequest = () => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  shouldContinue.value = false
  isRunning.value = false
  appendLog('已停止请求')
}

  </script>
  
  <style scoped>
.el-header {
    margin-bottom: 20px;
}
</style>
  